import Api from './api.service';

export default {
  get: (params) => Api.get('cities', { params }),
  search: (term = '') => Api.get(`cities?filter[name]=${term}`),
  searchByStateId: (term = '') => Api.get(`cities?filter[state_id]=${term}`),
  getId: (id) => Api.get(`cities/${id}`),
};
